<template>
  <b-form-group :label="properties.label">
    <date-picker v-model="propertyValue" size="sm" />
  </b-form-group>
</template>

<script>
import DatePicker from "../../controls/DatePicker";
export default {
  name: "DatePickerPropertyType",
  components: { DatePicker },
  props: ["properties", "property", "value"],
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-value", this.property, newValue);
      }
    }
  }
};
</script>
